import { render, staticRenderFns } from "./version_token.vue?vue&type=template&id=e3f9237c&vue3"
import script from "./version_token.vue?vue&type=script&lang=js&vue3"
export * from "./version_token.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports